import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  confirmationDialog: {
    "& .MuiDialog-paper": {
      margin: 0,
      [theme.breakpoints.up("sm")]: {
        marginLeft: `calc(${theme.widthTabletDrawer}px + env(safe-area-inset-left))`
      },
      [theme.breakpoints.up("lg")]: {
        marginLeft: `calc(${theme.widthDesktopDrawer}px + env(safe-area-inset-left))`
      }
    },
    "& .MuiPaper-root": {
      maxWidth: 300
    },
    "& .MuiDialogContent-root, & .MuiDialogTitle-root": {
      paddingLeft: 20,
      paddingRight: 20
    },
    "& .MuiDialogContent-root": {
      paddingTop: 14,
      paddingBottom: 16
    }
  },
  dialogTitleTypography: {
    fontSize: 20,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal"
  },
  dialogSubtitle: {
    paddingTop: 0
  },
  dialogSubtitleTypography: {
    fontSize: 14,
    textAlign: "left",
    lineHeight: "19px"
  },
  dialogBold: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: theme.palette.text.primary
  },
  dialogHorseInfo: {
    fontSize: 14
  },
  button: {
    fontSize: 16,
    color: theme.palette.text.secondary
  },
  confirmButton: {
    color: theme.palette.error.main
  }
}));
